// 微信小程序 WebView 使用的旧版 V8 引擎不支持 Array.prototype.at()（ES2022）
// vue-router v4 内部使用了 .at(-1)，在微信 WebView 中会报 "E.matched.at is not a function"
// 此 polyfill 在客户端最早执行，确保兼容性
export default defineNuxtPlugin(() => {
  // iOS 10+ 的 WKWebView 会忽略 viewport 里的 user-scalable=no，
  // 通过监听多指 touchmove 并阻止默认行为来全局禁用双指缩放
  document.addEventListener(
    'touchmove',
    (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault()
      }
    },
    { passive: false }
  )

  if (typeof Array.prototype.at !== 'function') {
    Array.prototype.at = function (index: number) {
      const len = this.length
      const relativeIndex = Math.trunc(index) || 0
      const k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex
      if (k < 0 || k >= len) return undefined
      return this[k]
    }
  }

  if (typeof String.prototype.at !== 'function') {
    String.prototype.at = function (index: number) {
      const len = this.length
      const relativeIndex = Math.trunc(index) || 0
      const k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex
      if (k < 0 || k >= len) return undefined
      return this[k]
    }
  }
})
